<template>
  <div id="App"> 
      <div id="header" class="center">
          <h1>Fernando Escoto | .NET Developer</h1>
          <h2>Laid back developer with an interest in web apps and data.</h2>
      </div>
<div id="social" class="social center">

        <div class="Media">
            <div class="Github">
                <a href="https://github.com/FernandoE99" target="_blank"> 
                    <div class="sociallink_icon"></div>
                    <div class="sociallink_title">Github</div>
                </a>
            </div>
        </div>

        <div class="Media">
            <div class="Twitter">
                <a class="noDecoration" href="https://twitter.com/FerEscoto99" target="_blank"> 
                    <div class="sociallink_icon"></div>
                    <div class="sociallink_title">Twitter</div>
                </a>
            </div>
        </div>

        <div class="Media">
            <div class="LinkedIn">
                <a class ="noDecoration" href="https://www.linkedin.com/in/fescoto99/" target="_blank"> 
                    <div class="sociallink_icon"></div>
                    <div class="sociallink_title">LinkedIn</div>
                </a>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
export default{
  name: "App",
  components:{

  }
}
</script>

<style>
@font-face{
    src: url("../src/font/GiveMeTheScoop-Regular.otf");
    font-family: Scoop;
}
@font-face{
    src: url("../src/font/Jelfish.otf");
    font-family: Jelfish;
}

body{
    /*background: url(./images/background.jpg) no-repeat, center;*/
    height: 100%;
    /*background-size: cover;*/
}
.center{
    position: fixed;
    top: 50%;
    left: 50%;
    /* bring your own prefixes */
    transform: translate(-50%, -90%);
    text-align: center;
    margin: auto;
    font-family: Jelfish;
    margin-bottom: 20px;
}
.center h1{
    font-size: 50px;
}

.social {
    margin-top: 120px;
    width: 100%;
    height: auto;
    transform: translate(-50%, 90%);
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-flow: wrap;
}

.sociallink_title{
    font-family: Scoop;
    font-size: large;
}

.a, a:hover{
    text-decoration: none;
}

.Media {
    margin: auto;
    text-align: center;
    margin-left: 5%;
    margin-right: 5%;
    box-sizing: border-box;
    display: flex;
}

.sociallink_icon{
    width: 64px;
    height: 64px;
    margin: auto;
}

/* ------------- Twitter -------------*/
.Media .Twitter .sociallink_icon{
    object-fit: contain;
    margin: auto;
    background: url("../src/images/Twitter/twitterdarkR.png") no-repeat, center;
}

.Media .Twitter .sociallink_icon:hover{
    object-fit: contain;
    margin: auto;
    background-image: url("../src/images/Twitter/twitterblueR.png");
}


/* ------------- Github -------------*/
.Media .Github .sociallink_icon{
    object-fit: contain;
    margin: auto;
    background: url("../src/images/Github/GitDark.png") no-repeat, center;
}

.Media .Github .sociallink_icon:hover{
    object-fit: contain;
    margin: auto;
    background-image: url("../src/images/Github/GitPurp.png");
}


/* ------------- LinkedIn -------------*/
.Media .LinkedIn .sociallink_icon{
    object-fit: contain;
    margin: auto;
    background: url("../src/images/LinkedIn/linkedinblackR.png") no-repeat, center;
}

.Media .LinkedIn .sociallink_icon:hover{
    object-fit: contain; 
    margin: auto;
    background-image: url("../src/images/LinkedIn/linkedinblueR.png");
}
</style>

